export const DEFAULT_MIN_WIDTH = '240px';
export const FOCUS_RING_WIDTH = 3;
export const ASYNC_OPTIONS_STALE_TIME = 60_000;
export const COMBO_BOX_SEARCH_DEBOUNCE_TIME = 300;
export const DISABLED_ASYNC_QUERY_KEY = ['ComboBox', 'disabled'];
export const EMPTY_OPTIONS_SEARCH = '';

export enum ComboBoxKeyboardKey {
    ArrowDown = 'ArrowDown',
    ArrowUp = 'ArrowUp',
    Backspace = 'Backspace',
    Enter = 'Enter',
    Space = ' ',
    Tab = 'Tab',
}
